export default {
  title: 'Updates',
  fields: {
    app_version: 'App-Version',
    description: 'Beschreibung',
    created_at: 'Erstellt am',
  },
};
